<script setup lang="ts">
withDefaults(defineProps<{
  hasCloseButton?: boolean
  theme?: 'primary' | 'success' | 'danger' | 'info' | 'neutral' | 'secondary',
  size?: 'xs' | 'sm' | 'md' | 'lg'
}>(), {
  hasCloseButton: false,
  theme: 'primary',
  size: 'md'
})

const emit = defineEmits<{
  (event: 'close'): void
}>()
</script>

<template>
  <span
    class="inline-flex items-center justify-center gap-x-0.5 rounded-full font-medium"
    :class="[
      theme === 'primary' ? 'bg-sky-blue-100 text-sky-blue-700' : '',
      theme === 'secondary' ? 'bg-sky-blue-600 text-gray-100/95' : '',
      theme === 'success' ? 'bg-green-cucumber-50 text-green-cucumber-600' : '',
      theme === 'danger' ? 'bg-red-100 text-red-700' : '',
      theme === 'info' ? 'bg-amber-100 text-amber-700' : '',
      theme === 'neutral' ? 'bg-gray-100 text-gray-700' : '',
      size === 'xs' ? 'px-1.5 py-0 text-xs text-[0.65rem]' : '',
      size === 'sm' ? 'px-2 py-0.5 text-xs' : '',
      size === 'md' ? 'px-3 py-0.5 text-sm' : '',
      size === 'lg' ? 'px-4 py-1 text-base' : '',
    ]"
    >
    <slot name="default" />
    <button v-if="hasCloseButton" @click.stop="emit('close')" type="button" class="group relative mt-[1px] -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-sky-blue-600/20">
      <svg viewBox="0 0 14 14" class="h-3.5 w-3.5 stroke-sky-blue-800/50 group-hover:stroke-sky-blue-800/75">
        <path d="M4 4l6 6m0-6l-6 6" />
      </svg>
      <span class="absolute -inset-1" />
    </button>
  </span>
</template>